import { render, staticRenderFns } from "./OppregOldQuestionnaire.vue?vue&type=template&id=1b313f28&scoped=true&"
import script from "./OppregOldQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./OppregOldQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./OppregOldQuestionnaire.vue?vue&type=style&index=0&id=1b313f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b313f28",
  null
  
)

export default component.exports